module.exports = {
    PARSE_ERROR: -32700,
    INVALID_REQUEST: -32600,
    METHOD_NOT_FOUND: -32601,
    INVALID_PARAMS: -32602,
    INTERNAL_ERROR: -32603,
    EXECUTION_ERROR: -32002,
    REQUEST_TIMEOUT: -32001,
};
